import { TFunction } from 'i18next';
import Cookies from 'js-cookie';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Language } from '../common/CountryMarketConfig';
import { useCountryMarketState } from '../controllers/CountryMarketController/CountryMarketState';

export interface LocalizationCookieHandler {
  changeAppLanguage(newLocale?: string): Promise<TFunction>;
  getLanguageFromCookie(): Language;
}

export const useLocalizationCookieHandler: () => LocalizationCookieHandler =
  () => {
    const { i18n } = useTranslation();

    const [{ locale }, { setLocale }] = useCountryMarketState();
    const dispatch = useDispatch();

    const changeAppLanguage = useCallback(
      (newLocale?: Language) => {
        const localization: Language =
          newLocale || locale || (Cookies.get('localization') as Language);

        if (localization) {
          dispatch(setLocale(localization));

          Cookies.set('localization', localization);

          return i18n.changeLanguage(localization);
        }

        return Promise.reject();
      },
      [dispatch, i18n, locale, setLocale],
    );

    const getLanguageFromCookie = useCallback(
      () => Cookies.get('localization') as Language,
      [],
    );

    return useMemo(
      () => ({
        changeAppLanguage,
        getLanguageFromCookie,
      }),
      [changeAppLanguage, getLanguageFromCookie],
    );
  };
